import React from 'react';
import classNames from 'classnames';
import { Check } from '@saleshandy/icons';
import { accessibleOnClick } from '../../../../../../shared/utils/accessible-on-click';
import { WIZARD_STEPS } from './constants';

type IProps = {
  currentStep: number;
  onStepClick: (step: number) => void;
};

const StepIndicator: React.FC<IProps> = ({ currentStep, onStepClick }) => (
  <div className="bs-lf-ext__steps" role="list">
    {WIZARD_STEPS.map(({ step, label }, idx) => {
      const isCompleted = currentStep > step;
      const isActive = currentStep === step;

      return (
        <React.Fragment key={step}>
          {idx > 0 && (
            <span
              className={classNames('bs-lf-ext__step-connector', {
                'bs-lf-ext__step-connector--complete': currentStep > idx,
              })}
              aria-hidden
            />
          )}
          <div
            className="bs-lf-ext__step"
            role="listitem"
            {...accessibleOnClick(() => onStepClick(step))}
          >
            <span
              className={classNames('bs-lf-ext__step-dot', {
                'bs-lf-ext__step-dot--active': isActive,
                'bs-lf-ext__step-dot--completed': isCompleted,
              })}
            >
              {isCompleted ? (
                <Check width={16} height={16} className="white-txt-1" />
              ) : (
                step
              )}
            </span>
            <span
              className={classNames('bs-lf-ext__step-label', 'regular-2', {
                'semibold-2 blue-txt-11': isActive,
                'green-txt-7': isCompleted,
                'gray-txt-7': !isActive && !isCompleted,
              })}
            >
              {label}
            </span>
          </div>
        </React.Fragment>
      );
    })}
  </div>
);

export default StepIndicator;
